import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { CcyLookupService } from "shared/cubiq-services/lookup/model/impl/CcyLookupService";
import { BmarkRiskData } from "shared/cubiq-services/model/benchmarks/BmarkRiskData.model";

/**
 * BM-Specific Order amount helper for formatting Swap amounts. Swap amounts are normally shown in Millions
 * with the actual amount available in a tooltip
 */
export class BMOrderAmountHelper {
  constructor(private ccyLookupService: CcyLookupService) {}

  public formatAmount(
    fixedCcy: string,
    fixedAmt: CubiqTS.BigNumber,
    isSwap: boolean,
    swapNearAmount: CubiqTS.BigNumber,
    swapFarAmount: CubiqTS.BigNumber,
    includeCurrency: boolean = false,
    showSign: boolean = false,
  ) {
    let result: string = null;

    const ccy = this.ccyLookupService.getCcy(fixedCcy);
    let precision: number = 0;

    if (isSwap) {
      let suffix: string = "?";

      let nearAmount = swapNearAmount;
      let farAmount = swapFarAmount;

      if (ccy) {
        if (ccy.positionUnitId === CubiqTS.PositionUnit.Million) {
          precision = 2;
          suffix = "M";
          nearAmount = nearAmount.dividedBy("1e6");
          farAmount = farAmount.dividedBy("1e6");
        } else {
          precision = ccy.minorUnitsQty.toNumber();
          suffix = "Oz";
        }

        let near = `${nearAmount.toFixed(precision)}${suffix}`;
        let far = `${farAmount.toFixed(precision)}${suffix}`;

        if (showSign == true) {
          if (nearAmount.isPositive()) {
            near = `+${near}`;
          }

          if (farAmount.isPositive()) {
            far = `+${far}`;
          }
        }

        result = `${near} / ${far}`;
      }
    } else {
      if (ccy != null && ccy.minorUnitsQty != null) {
        precision = ccy.minorUnitsQty.toNumber();
      }
      result = fixedAmt.toFormat(precision);

      if (showSign == true && fixedAmt.isPositive()) {
        result = `+${result}`;
      }
    }

    if (result != null) {
      if (includeCurrency) {
        result = `${result} ${fixedCcy}`;
      }
    } else {
      result = "-";
    }

    return result;
  }

  public formatAmountTooltip(
    fixedAmt: CubiqTS.BigNumber,
    isSwap: boolean,
    swapNearAmount: CubiqTS.BigNumber,
    swapFarAmount: CubiqTS.BigNumber,
    fixedCcy: string,
    showSign: boolean = false,
  ) {
    const ccy = this.ccyLookupService.getCcy(fixedCcy);
    let precision: number = 0;

    if (ccy != null && ccy.minorUnitsQty != null) {
      precision = ccy.minorUnitsQty.toNumber();
    }

    let result: string;

    if (isSwap) {
      let near = `${swapNearAmount.toFormat(precision)}`;
      let far = `${swapFarAmount.toFormat(precision)}`;

      if (showSign == true) {
        if (swapNearAmount.isPositive()) {
          near = `+${near}`;
        }

        if (swapFarAmount.isPositive()) {
          far = `+${far}`;
        }
      }

      result = `${near}/${far}`;
    } else {
      result = fixedAmt.toFormat(precision);
      if (showSign == true && fixedAmt.isPositive()) {
        result = `+${result}`;
      }
    }

    return result;
  }

  public formatUSDAmount(risk: BmarkRiskData) {
    // if (risk.isSwap) {
    //   let nearAmount = risk.nearUSDAmount;
    //   let farAmount = risk.farUSDAmount;
    //   return `${nearAmount.dividedBy("1e6").toFixed(0)}M / ${farAmount
    //     .dividedBy("1e6")
    //     .toFixed(0)}M`;
    // } else {
    // return risk.usdAmount.toFixed(0);
    // }
    // AJB - USD amounts are currently only available on risk level so cannot get
    // get near/far amounts
    return risk.usdAmount.toFormat(0);
  }

  public formatUSDTooltip(risk: BmarkRiskData) {
    let precision: number = 0;

    if (risk.isSwap) {
      let nearAmount = risk.nearUSDAmount;
      let farAmount = risk.farUSDAmount;
      return `${nearAmount.toFixed(precision)}/${farAmount.toFixed(precision)}`;
    } else {
      return risk.usdAmount.toFixed(precision);
    }
  }
}
